import React, { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router'



function Cancel() {

    useEffect(() => {
        setTimeout(() => {
            window.close();
        }, 2000);
    }, []);

    return (<div className="manage-container">

        <h3>Payment cancelled! Please try again.</h3>

        <p>This page will close automatically.</p>

        <style jsx>{`
            
            .manage-container {
                margin: 0 auto;
                width: 100%;
                text-align: center;
            }

            `}</style>

    </div>);

};

export default Cancel;

export const Route = createFileRoute('/_authenticated/settings/subscription/cancel')({ component: Cancel })
